import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { change as changeFieldValue, reduxForm, reset } from 'redux-form';
import { showAlertMsg, showSuccessMsg } from '../../util/messagesUtil';
import cadastrarControleEmissaoBpeUsuario from '../../actions/bpe/cadastrarControleEmissaoBpeUsuario';
import buscarUsuarioPorEmpresaNomeIdEmail from '../../actions/usuario/buscarUsuarioEmpresaPorParte';
import Select from 'react-select';
import $ from 'jquery';
import { formasPagamentoControleEmissaoBpe } from '../../util/constantsUtil';

export class ModalCadastrarControleEmissaoBpeUsuario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usuarioEmpresaSelecionado: null,
      tiposPagamentoSelecionados: [],
      usuarios: [],
      carregandoUsuarios: false
    };
    this.submit = this.submit.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.fecharModal = this.fecharModal.bind(this);
    this.handleUsuarioChange = this.handleUsuarioChange.bind(this);
    this.handleTipoPagamentoChange = this.handleTipoPagamentoChange.bind(this);
    this.buscarUsuarios = this.buscarUsuarios.bind(this);
  }

  componentDidMount() {
    // Listener para quando o modal é exibido via Bootstrap
    $('#modalCadastrarControleEmissaoBpeUsuario').on('shown.bs.modal', () => {
      if (this.props.controleEdicao) {
        this.preencherDadosEdicao(this.props.controleEdicao);
      } else {
        this.limparFormulario();
      }
    });
    
    if (this.props.controleEdicao) {
      this.preencherDadosEdicao(this.props.controleEdicao);
    }
  }

  componentDidUpdate(prevProps) {
    // Quando controleEdicao muda, preencher os dados
    if (this.props.controleEdicao && prevProps.controleEdicao !== this.props.controleEdicao) {
      this.preencherDadosEdicao(this.props.controleEdicao);
    }
    // Quando controleEdicao é limpo (null), limpar o formulário
    if (!this.props.controleEdicao && prevProps.controleEdicao) {
      this.limparFormulario();
    }
  }

  componentWillUnmount() {
    // Remover listener quando componente for desmontado
    $('#modalCadastrarControleEmissaoBpeUsuario').off('shown.bs.modal');
  }

  preencherDadosEdicao(controle) {
    if (!controle) {
      return;
    }
    this.setState({
      usuarioEmpresaSelecionado: {
        value: controle.usuarioEmpresaId,
        label: `${controle.nomeUsuario} (${controle.emailUsuario})`
      },
      tiposPagamentoSelecionados: controle.tiposPagamento || []
    });
  }

  buscarUsuarios(inputValue) {
    if (!inputValue || inputValue.length < 2) {
      this.setState({ usuarios: [] });
      return;
    }

    const empresaId = this.props.codigoEmpresaSelecionada;
    if (!empresaId) {
      return;
    }

    this.setState({ carregandoUsuarios: true });
    this.props.buscarUsuarioPorEmpresaNomeIdEmail(inputValue, empresaId)
      .then(response => {
        const usuarios = response.payload.data.map(ue => ({
          value: ue.usuarioEmpresaId,
          label: `${ue.nome} (${ue.email})`
        }));
        this.setState({ usuarios, carregandoUsuarios: false });
      })
      .catch(() => {
        this.setState({ carregandoUsuarios: false });
      });
  }

  handleUsuarioChange(selectedOption) {
    this.setState({ usuarioEmpresaSelecionado: selectedOption });
  }

  handleTipoPagamentoChange(tipoPagamento, checked) {
    const tiposPagamento = [...this.state.tiposPagamentoSelecionados];
    if (checked) {
      if (!tiposPagamento.includes(tipoPagamento)) {
        tiposPagamento.push(tipoPagamento);
      }
    } else {
      const index = tiposPagamento.indexOf(tipoPagamento);
      if (index > -1) {
        tiposPagamento.splice(index, 1);
      }
    }
    this.setState({ tiposPagamentoSelecionados: tiposPagamento });
  }

  limparFormulario() {
    this.setState({
      usuarioEmpresaSelecionado: null,
      tiposPagamentoSelecionados: [],
      usuarios: []
    });
    if (this.props.reset) {
      this.props.reset('formularioCadastroControleUsuario');
    }
  }

  submit() {
    if (!this.state.usuarioEmpresaSelecionado || !this.state.usuarioEmpresaSelecionado.value) {
      showAlertMsg('Selecione um usuário válido.');
      return;
    }

    if (this.state.tiposPagamentoSelecionados.length === 0) {
      showAlertMsg('Selecione ao menos um tipo de pagamento.');
      return;
    }

    const config = {
      id: this.props.controleEdicao ? this.props.controleEdicao.id : null,
      usuarioEmpresaId: this.state.usuarioEmpresaSelecionado.value,
      tiposPagamento: this.state.tiposPagamentoSelecionados
    };

    this.props.cadastrarControleEmissaoBpeUsuario(config).then(() => {
      showSuccessMsg('Configuração salva com sucesso');
      this.limparFormulario();
      if (this.props.fecharModalEdicao) {
        this.props.fecharModalEdicao();
      }
      this.props.listarControles();
      this.fecharModal();
    }).catch(error => {
      if (error.response && error.response.data && error.response.data.message) {
        showAlertMsg(error.response.data.message);
      } else {
        showAlertMsg('Erro ao salvar configuração.');
      }
    });
  }

  fecharModal() {
    $('#modalCadastrarControleEmissaoBpeUsuario')
      .modal('hide');
    $('#modalCadastrarControleEmissaoBpeUsuario')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.limparFormulario();
    if (this.props.fecharModalEdicao) {
      this.props.fecharModalEdicao();
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    const tiposPagamento = formasPagamentoControleEmissaoBpe.map(it => ({ codigo: it.value, label: it.label }));

    return (
      <div className="modal fade show" id='modalCadastrarControleEmissaoBpeUsuario' role='dialog'
        aria-labelledby='modalCadastrarControleEmissaoBpeUsuario' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>{this.props.controleEdicao ? 'Editar' : 'Cadastrar'} Configuração BPE por Usuário</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                onClick={this.fecharModal}>
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={(e) => { e.preventDefault(); this.submit(); }}>
                <div className="form-row">
                  <div className="col-12 mb-3">
                    <label>Usuário</label>
                    <Select
                      maxMenuHeight={200}
                      menuPlacement="auto"
                      noOptionsMessage={() => ('Digite pelo menos 2 caracteres para buscar')}
                      placeholder='Digite para buscar usuário...'
                      options={this.state.usuarios}
                      value={this.state.usuarioEmpresaSelecionado}
                      onChange={this.handleUsuarioChange}
                      onInputChange={this.buscarUsuarios}
                      isLoading={this.state.carregandoUsuarios}
                      isDisabled={!!this.props.controleEdicao}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="col-12 mb-3">
                    <label>Tipos de Pagamento</label>
                    <div className="form-group">
                      {tiposPagamento.map(tipo => (
                        <div key={tipo.codigo} className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`tipoPagamento_${tipo.codigo}`}
                            checked={this.state.tiposPagamentoSelecionados.includes(tipo.codigo)}
                            onChange={(e) => this.handleTipoPagamentoChange(tipo.codigo, e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor={`tipoPagamento_${tipo.codigo}`}>
                            {tipo.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button 
                    type="button" 
                    className="btn btn-outline-secondary"
                    data-dismiss="modal"
                    onClick={this.fecharModal}>
                    Cancelar
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-laranja float-left"
                    disabled={!this.state.usuarioEmpresaSelecionado || this.state.tiposPagamentoSelecionados.length === 0}>
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  const empresaSelecionada = state.empresaSelecionada;
  if (!empresaSelecionada) {
    return {
      codigoEmpresaSelecionada: null
    };
  }
  // empresaSelecionada pode ter empresa.id ou id diretamente
  return {
    codigoEmpresaSelecionada: empresaSelecionada.empresa?.id || empresaSelecionada.id || null
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarControleEmissaoBpeUsuario,
    buscarUsuarioPorEmpresaNomeIdEmail,
    reset
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastroControleUsuario'
})(ModalCadastrarControleEmissaoBpeUsuario));

